





























































import { Component, Vue, Prop } from 'vue-property-decorator';

export interface FilterItem {
  id: string;
  value: string;
  isChecked: boolean;
  isDisabled?: boolean;
}

@Component({})
export default class FilterBase extends Vue {
  @Prop()
  filterItems!: FilterItem[];

  @Prop({ default: false })
  isSingleSelect!: boolean;

  @Prop()
  name!: string;

  @Prop({ default: false })
  isDropdown!: boolean;

  @Prop({ default: false })
  initialIsAllSelected!: boolean;

  items: FilterItem[] = [];
  dropdownHeight = '0';
  isDropdownOpen = false;
  isAllSelected = false;

  get dropdownIconRef() {
    return `${this.name}-dropdown-icon-filter`;
  }

  get containerClass() {
    if (this.isDropdown) {
      return 'py-10 flex w-full justify-between text-gray-200 cursor-pointer';
    } else {
      return 'mb-10 w-full font-bold';
    }
  }

  get availableItems(): number {
    return this.filterItems.filter(item => {
      return !item.isDisabled;
    }).length;
  }

  created() {
    if (this.filterItems) {
      this.items = this.filterItems;
      this.isAllSelected = this.initialIsAllSelected;
    }
  }

  mounted() {
    if (this.isDropdown) {
      this.dropdownInitialHeight();
    }
  }

  checkClicked(item: FilterItem) {
    if (item.isDisabled || (this.availableItems === 1 && this.isSingleSelect)) {
      return;
    }

    const index = this.items.indexOf(item);

    if (this.isSingleSelect) {
      this.items = this.items.map(item => {
        if (!item.isDisabled) {
          return {
            isChecked: false,
            id: item.id,
            value: item.value,
          };
        } else {
          return item;
        }
      });
    }

    this.items[index].isChecked = !this.items[index].isChecked;

    let isAllSelected = true;

    this.items.forEach(item => {
      if (!item.isChecked && !item.isDisabled) {
        isAllSelected = false;
      }
    });

    this.isAllSelected = isAllSelected;

    this.$emit('filterChanged', {
      name: this.name,
      items: this.items,
      isAllSelected: this.isAllSelected,
    });
  }

  selectAllClicked() {
    let selectAll = true;

    if (this.isAllSelected) {
      selectAll = false;
    }

    this.items = this.items.map(item => {
      const isChecked = item.isDisabled ? false : selectAll;
      return {
        isChecked: isChecked,
        id: item.id,
        value: item.value,
        isDisabled: item.isDisabled || false,
      };
    });

    this.isAllSelected = selectAll;

    this.$emit('filterChanged', {
      name: this.name,
      items: this.items,
      isAllSelected: this.isAllSelected,
    });
  }

  toggleDropdown() {
    if (this.isDropdown) {
      const dropdownIcon: any = this.$refs[this.dropdownIconRef];

      if (this.isDropdownOpen) {
        dropdownIcon.className = 'rotate-down dropdown-icon-filter';
      } else {
        dropdownIcon.className = 'rotate-up dropdown-icon-filter';
      }
      this.isDropdownOpen = !this.isDropdownOpen;
    }
  }

  dropdownInitialHeight() {
    const filter: any = this.$refs[this.name];
    filter.style.height = 'auto';
    filter.style.position = 'absolute';
    filter.style.visibility = 'hidden';
    filter.style.display = 'block';

    const height = getComputedStyle(filter).height;
    this.dropdownHeight = height;

    filter.style.position = null;
    filter.style.visibility = null;
    filter.style.display = null;
    filter.style.height = 0;
  }
}
